import React from 'react'

// A pasted address or a phone keyboard's auto-space leaves a leading or trailing space
// that is invisible in the field but fails the format check, so the message points at an
// address that looks perfectly correct. Normalising when the field loses focus makes the
// correction visible. Only a value that actually changed is written back, so blurring a
// field that is already showing an error does not silently clear the message.
// Passwords are excluded by design: whitespace is significant there.
export function trimOnBlur(apply: (value: string) => void, then?: () => void) {
  return (e: React.FocusEvent<HTMLInputElement>) => {
    const trimmed = e.target.value.trim()
    if (trimmed !== e.target.value) apply(trimmed)
    then?.()
  }
}
